import React, { useState } from "react";

function Navbar() {
  const [open, setOpen] = useState(false);

  const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) section.scrollIntoView({ behavior: "smooth" });
    setOpen(false);
  };

  return (
    <nav className="w-full bg-[#151748]/90 backdrop-blur-lg shadow-md px-6 md:px-10 py-4 flex justify-between items-center fixed top-0 left-0 z-50 h-20">

        <h1 onClick={() => scrollToSection("home")}
      className="text-2xl font-bold text-white cursor-pointer">
    Deepesh S Kanchan
  </h1>

  {/* Mobile Button */}
  <button
    className="md:hidden text-[#E9A87A] text-3xl"
    onClick={() => setOpen(!open)}
  >
    ☰
  </button>

  <ul
    className={`
      md:flex md:space-x-10 font-semibold text-white
      absolute md:static 
      w-full md:w-auto left-0
      transition-all duration-300 items-center

      ${open ? "top-20 bg-[#151748]/95 py-4" : "top-[-350px]"}
    `}
  >
    {["home", "about", "education", "research", "contact"].map((section) => (
      <li
        key={section}
        className="p-3 md:p-0 cursor-pointer hover:text-[#E9A87A]"
        onClick={() => scrollToSection(section)}
      >
        {section.charAt(0).toUpperCase() + section.slice(1)}
      </li>
    ))}
      </ul>
    </nav>
  );
}

export default function App() {
  return (
    <div className="min-h-screen bg-[#CDE3EE]">
      <Navbar />

      {/* HERO SECTION */}
      <div
        id="home"
        className="pt-32 w-fullbg-[#003B73] bg-gradient-to-b from-[#151748] to-[#CDE3EE] bg-repeat 
        py-16 px-4 md:px-6 flex flex-col items-center fade-in"
      >
        <div className="max-w-5xl mx-auto flex flex-col md:flex-row items-center md:items-start gap-8 text-center md:text-left">
          
          <img
            src="/profile.jpg"
            alt="Profile"
            className="w-32 h-32 md:w-56 md:h-56 rounded-full shadow-xl border-4 border-white object-cover object-top bg-white p-2"
          />

          <div>
            <h1 className="text-3xl md:text-4xl font-extrabold text-gray-900">
              Deepesh S. Kanchan
            </h1>
            <p className="text-lg md:text-xl text-gray-700 mt-2">
              Assistant Professor – Electrical & Electronics Engineering  
              <br />St Joseph Engineering College, Mangaluru
            </p>
            <p className="mt-4 text-gray-800 leading-relaxed text-base md:text-lg max-w-xl">
              Technical Writer and Assistant Professor with 20+ years of 
              experience in engineering documentation, AI-adjacent systems, 
              electrical communication, and responsible technology communication.
            </p>
          </div>
          <a
  href="/CV.pdf"
  download
  className="inline-flex items-center gap-3 mt-4 bg-blue-700 text-white px-6 py-3 rounded-xl shadow hover:bg-blue-800 transition"
>
  <img src="https://cdn-icons-png.flaticon.com/512/724/724933.png" className="w-5" />
  Download CV
</a>

        </div>
      </div>

      {/* MAIN CONTENT */}
      <div className="p-4 md:p-6 flex flex-col items-center">

        {/* ABOUT SECTION */}
        <section
          id="about"
          className="w-full max-w-5xl mx-auto bg-white/20 backdrop-blur-xl border border-[#E8A57C]/30 shadow-[0_0_20px_rgba(21,23,72,0.2)] backdrop-blur-xl 
          rounded-xl md:rounded-3xl shadow-lg p-6 md:p-14 mt-10 border border-gray-200 fade-in"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-8 
            border-l-4 border-[#D27644]   // dark orange pl-4">
            About Me
          </h2>

          <p className="text-gray-700 leading-relaxed text-lg md:text-xl mb-6">
            I am an experienced <strong>Assistant Professor</strong> in the 
            <strong> Electrical & Electronics Engineering (EEE)</strong> department 
            at <strong>St Joseph Engineering College, Mangaluru</strong>, and a 
            <strong> Technical Writer</strong> with over <strong>20 years of combined 
            academic and industry experience</strong>.
          </p>

          <p className="text-gray-700 leading-relaxed text-lg md:text-xl mb-6">
            I specialize in producing <strong>structured, accurate, and 
            accessible technical documentation</strong> for AI systems, 
            engineering workflows, EV battery research, and safety-critical systems.
          </p>

          <p className="text-gray-700 leading-relaxed text-lg md:text-xl mb-6">
            At St Joseph Engineering College, I mentor students in 
            <strong> technical communication, research writing, engineering 
            documentation, and system-level understanding</strong>.
          </p>

          <p className="text-gray-700 leading-relaxed text-lg md:text-xl">
            My areas of interest include <strong>Power & Energy Systems</strong>, 
            <strong> Battery Health Monitoring for EVs</strong>, 
            <strong> Smart Grids</strong>, and 
            <strong> AI-driven Documentation</strong>.
          </p>
        </section>

        {/* EDUCATION SECTION */}
        {/* EDUCATION SECTION */}
<section
  id="education"
  className="w-full max-w-5xl mx-auto bg-white/20 backdrop-blur-xl border border-[#E8A57C]/30 shadow-[0_0_20px_rgba(21,23,72,0.2)] backdrop-blur-xl backdrop-blur-xl 
  rounded-xl md:rounded-3xl shadow-lg p-6 md:p-14 mt-10 border border-gray-200 fade-left"
>
  <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-10 
    border-l-4 border-[#D27644]   // dark orange pl-4">
    Education
  </h2>

  <div className="space-y-10">

    {/* PhD */}
    <div className="flex items-start space-x-5">
      <img
        src="https://img.icons8.com/?size=100&id=SnbJlt3UekJ0&format=png&color=000000"
        className="w-10 opacity-80 mt-1"
      />

      <div className="flex flex-col">
        <h3 className="text-xl font-semibold">Ph.D. (Pursuing) – Electrical Engineering</h3>
        <p className="text-gray-700 text-lg">Battery Health Monitoring for EV Batteries</p>

        <ul className="text-gray-600 text-md mt-2 list-disc ml-6 space-y-1">
          <li>Research focus: EV battery diagnostics & degradation modelling</li>
          <li>Working on predictive State of Health (SOH) algorithms</li>
          <li>Developing structured documentation for EV monitoring systems</li>
        </ul>
      </div>
    </div>

    {/* MTech */}
    <div className="flex items-start space-x-5">
      <img
        src="https://img.icons8.com/?size=100&id=LnnIUSVMXFMU&format=png&color=000000"
        className="w-10 opacity-80 mt-1"
      />

      <div className="flex flex-col">
        <h3 className="text-xl font-semibold">M.Tech – Power & Energy Systems</h3>
        <p className="text-gray-700 text-lg">National Institute of Technology Karnataka (NITK), Surathkal</p>

        <ul className="text-gray-600 text-md mt-2 list-disc ml-6 space-y-1">
          <li>Specialization in power system design & stability</li>
          <li>Smart grid technologies & renewable integration studies</li>
          <li>Key subjects: Power Electronics, Power Quality, HVDC</li>
        </ul>
      </div>
    </div>

    {/* BE */}
    <div className="flex items-start space-x-5">
      <img
        src="https://img.icons8.com/?size=100&id=23319&format=png&color=000000"
        className="w-10 opacity-80 mt-1"
      />

      <div className="flex flex-col">
        <h3 className="text-xl font-semibold">B.E – Electrical & Electronics Engineering</h3>
        <p className="text-gray-700 text-lg">National Institute of Technology Karnataka (NITK), Surathkal</p>

        <ul className="text-gray-600 text-md mt-2 list-disc ml-6 space-y-1">
          <li>Strong fundamentals in core EEE subjects</li>
          <li>Projects in power systems & electrical communication</li>
          <li>Developed interest in documentation & teaching methodologies</li>
        </ul>
      </div>
    </div>

  </div>
</section>

        {/* RESEARCH SECTION */}
        <section
          id="research"
          className="w-full max-w-5xl mx-auto bg-white/20 backdrop-blur-xl border border-[#E8A57C]/30 shadow-[0_0_20px_rgba(21,23,72,0.2)] backdrop-blur-xl 
          rounded-xl md:rounded-3xl shadow-lg p-6 md:p-14 mt-10 border border-gray-200 fade-in"
        >
          <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-10 
            border-l-4 border-[#D27644]   // dark orange pl-4">
            Research Interests
          </h2>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            
{/* Battery */}
<div className="rounded-2xl border border-[#1A1C4B] 
  bg-gradient-to-b from-[#E9A87A] to-[#CDE3EE] 
  p-8 shadow-md hover:shadow-2xl transition-all duration-500 
  animate-float hover:scale-[1.05]">
  
  <img src="https://img.icons8.com/?size=100&id=HXCS0QeWhzIG&format=png&color=000000"
    className="w-20 mx-auto mb-4" />

  <h3 className="text-2xl font-semibold text-[#1A1C4B] text-center mb-3">
    Battery Health Monitoring (EV)
  </h3>

  <p className="text-[#1A1C4B]/80 text-center">
    Predictive modelling, degradation analysis, and EV battery diagnostics.
  </p>
</div>

{/* Power Systems */}
<div className="rounded-2xl border border-[#1A1C4B] 
  bg-gradient-to-b from-[#E9A87A] to-[#CDE3EE] 
  p-8 shadow-md hover:shadow-2xl transition-all duration-500
  animate-float hover:scale-[1.05]">

  <img src="https://img.icons8.com/?size=100&id=qLNsRv7IfCEg&format=png&color=000000" 
    className="w-20 mx-auto mb-4" />

  <h3 className="text-2xl font-semibold text-[#1A1C4B] text-center mb-3">
    Power & Energy Systems
  </h3>

  <p className="text-[#1A1C4B]/80 text-center">
    Smart grids, renewable energy integration, and power system analysis.
  </p>
</div>

{/* AI Documentation */}
<div className="rounded-2xl border border-[#1A1C4B] 
  bg-gradient-to-b from-[#E9A87A] to-[#CDE3EE] 
  p-8 shadow-md hover:shadow-2xl transition-all duration-500
  animate-float hover:scale-[1.05]">

  <img src="https://cdn-icons-png.flaticon.com/512/4712/4712100.png" 
    className="w-20 mx-auto mb-4" />

  <h3 className="text-2xl font-semibold text-[#1A1C4B] text-center mb-3">
    AI-driven Documentation
  </h3>

  <p className="text-[#1A1C4B]/80 text-center">
    Technical documentation for AI workflows & safety-critical systems.
  </p>
</div>
</div>
        </section>

        {/* CONTACT SECTION */}
        {/* CONTACT SECTION */}
<section
  id="contact"
  className="w-full max-w-5xl mx-auto bg-white/20 backdrop-blur-xl border border-[#E8A57C]/30 shadow-[0_0_20px_rgba(21,23,72,0.2)] backdrop-blur-xl 
  rounded-xl md:rounded-3xl shadow-lg p-6 md:p-14 mt-10 border border-gray-200"
>
  <h2 className="text-2xl md:text-3xl font-bold text-blue-900 mb-8 
    border-l-4 border-[#D27644]   // dark orange pl-4">
    Contact
  </h2>

  <div className="space-y-6">

    {/* Email */}
    <div className="flex items-center space-x-4">
      <img src="https://cdn-icons-png.flaticon.com/512/542/542638.png" className="w-6 opacity-80" />
      <p className="text-lg text-gray-700">
        <strong>Email:</strong>{" "}
        <a
          href="mailto:deepesh.kanchan@gmail.com"
          className="text-blue-600 hover:underline"
        >
          deepesh.kanchan@gmail.com
        </a>
      </p>
    </div>

    {/* Location */}
    <div className="flex items-center space-x-4">
      <img src="https://cdn-icons-png.flaticon.com/512/535/535188.png" className="w-6 opacity-80" />
      <p className="text-lg text-gray-700">
        <strong>Location:</strong> Mangaluru, Karnataka, India
      </p>
    </div>

    {/* LinkedIn */}
    <div className="flex items-center space-x-4">
      <img src="https://cdn-icons-png.flaticon.com/512/3536/3536505.png" className="w-6 opacity-80" />
      <p className="text-lg text-gray-700">
  <strong>LinkedIn:</strong>{" "}
  <a
    href="https://www.linkedin.com/in/deepesh-kanchan-7b198a114/"
    target="_blank"
    rel="noopener noreferrer"
    className="text-blue-600 hover:underline"
  >
    View Profile
  </a>
      </p>
    </div>
  </div>

  <div className="mt-8 pt-6 border-t border-gray-300 space-y-3">
    <p className="text-lg text-gray-700">
      <strong>Current Role:</strong> Assistant Professor – EEE Dept., St Joseph Engineering College
    </p>

    <p className="text-lg text-gray-700">
      <strong>Core Skills:</strong> Technical Writing, Engineering Documentation, AI Communication
    </p>

    <p className="text-lg text-gray-700">
      <strong>Tools:</strong> MATLAB, Simulink, ETAP, ChatGPT, Gemini, MS Office Suite
    </p>
  </div>
</section>

      </div>

      {/* FOOTER */}
      <footer className="mt-20 bg-[#0d1b3d] text-white py-10 px-6">
        <div className="max-w-6xl mx-auto text-center space-y-4">
          <h3 className="text-xl font-semibold">Deepesh S. Kanchan</h3>
          <p className="text-gray-300 text-sm">
            Assistant Professor – Electrical & Electronics Engineering  
          </p>
          <p className="text-gray-300 text-sm">
            St Joseph Engineering College, Mangaluru
          </p>

          <p className="text-gray-400 text-xs mt-6">
            © {new Date().getFullYear()} Deepesh S. Kanchan. All Rights Reserved.
          </p>
        </div>
      </footer>
    </div>
  );
}
